import React, { useState, useContext } from 'react';
import classNames from 'classnames';
import styles from './Login.module.scss';
import { useForm, SubmitHandler, useFormState } from 'react-hook-form';
import { Button, Form, FormfieldString, LoginBox, Paragraph } from 'ui/components';
import { DictionaryContext } from 'application/adapters/context/Dictionary';

interface FormData {
	email: string;
	password: string;
}

export interface LoginProps {
	className?: string;
	heading?: string;
	text?: string;
}

export const Login: React.FC<LoginProps> = ({
	// className,
	heading,
	text,
}) => {
	const dictionary = useContext(DictionaryContext);

	// FORM HANDLING
	// const [allErrors, setallErrors] = useState(0);
	const [errorSummary, setErrorSummary] = useState(0);
	const { register, handleSubmit, control } = useForm<FormData>();

	const onSubmit: SubmitHandler<FormData> = (data) => {
		alert(`Thank for submitting, ${JSON.stringify(data)}`);
	};

	const { errors } = useFormState({
		control,
	});

	const onError = (data) => {
		const totalErrors = Object.keys(data).length;
		setErrorSummary(totalErrors);
		// setallErrors(data);
	};

	const errorMessage = dictionary.getValue('Form.ErrorMessage', null, 'This field is required');
	// / FORM HANDLING

	return (
		<LoginBox heading={heading}>
			{text && <Paragraph>{text}</Paragraph>}
			<Form onSubmit={handleSubmit(onSubmit, onError)} errorSummary={errorSummary} errorSummaryPosition="bottom">
				<FormfieldString
					id="email"
					name="email"
					label={dictionary.getValue('Form.Email', null, 'Email')}
					type="email"
					register={register}
					className={classNames(styles.Login_Formfield, 'u-bottom-margin--md')}
					state={
						errors.email
							? {
									hasError: true,
									required: true,
							  }
							: { required: true }
					}
					errorMessage={errorMessage}
					pattern="^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
				/>

				<FormfieldString
					id="password"
					name="password"
					label={dictionary.getValue('Form.Password', null, 'Password')}
					type="password"
					register={register}
					className={classNames(styles.Login_Formfield, 'u-bottom-margin--lg')}
					state={
						errors.password
							? {
									hasError: true,
									required: true,
							  }
							: { required: true }
					}
					errorMessage={errorMessage}
					// pattern="^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
				/>

				<Button
					className={classNames(styles.Login_button)}
					style="primary"
					type="submit"
					aria-label={dictionary.getValue('Form.LogIn', null, 'Log in')}
				>
					{dictionary.getValue('Form.LogIn', null, 'Log in')}
				</Button>
			</Form>
		</LoginBox>
	);
};
